import React from 'react';
import { Outlet } from 'react-router-dom';

function DashboardLayout() {
  return (
    <div style={{ width: '100%', minHeight: '100vh' }}>
      {/* Only render dashboard content - no main header/footer */}
      <Outlet />
    </div>
  );
}

export default DashboardLayout;
